import DictionaryTypes from '../../models/dictionary-types';
import Subjects from '../../models/subjects';
import { SelectorStore } from './selector-store';

export default class ThemeFilter extends SelectorStore {

    constructor(subject: Subjects, multiple?: boolean) {
        super(subject, DictionaryTypes.themes, multiple);
    }
}